import { getCurrentServer, getStoreOtherJson } from "./globalData.js";

const GOODS_DETAIL_SELECTED_COUNTRY_STORAGE_PREFIX = "goodsDetailSelectedCountry";

function normalizeText(value = "") {
  return String(value ?? "").trim();
}

function normalizeCompareText(value = "") {
  return normalizeText(value).toLowerCase();
}

export function getGoodsDetailSelectedCountryConfig(storeInfo = {}) {
  const otherJson = getStoreOtherJson(storeInfo);
  const candidates = [
    otherJson?.mallSiteConfig?.goodsDetailSelectedCountry,
    storeInfo?.storePageInfo?.mallSiteConfig?.goodsDetailSelectedCountry,
    storeInfo?.mallSiteConfig?.goodsDetailSelectedCountry,
  ];

  for (const candidate of candidates) {
    const normalizedValue = normalizeText(candidate);
    if (normalizedValue) {
      return normalizedValue;
    }
  }

  return "";
}

export function getGoodsDetailSelectedCountryStorageKey(
  currentServer = getCurrentServer(),
) {
  const normalizedServer = normalizeText(currentServer).replace(/^https?:\/\//i, "");
  return `${GOODS_DETAIL_SELECTED_COUNTRY_STORAGE_PREFIX}:${normalizedServer || "default"}`;
}

export function readGoodsDetailSelectedCountryCache(
  currentServer = getCurrentServer(),
) {
  if (!process.client || typeof window === "undefined") {
    return "";
  }

  try {
    return normalizeText(
      window.localStorage.getItem(
        getGoodsDetailSelectedCountryStorageKey(currentServer),
      ),
    );
  } catch (error) {
    return "";
  }
}

export function writeGoodsDetailSelectedCountryCache(
  value,
  currentServer = getCurrentServer(),
) {
  if (!process.client || typeof window === "undefined") {
    return "";
  }

  const normalizedValue = normalizeText(value);

  try {
    const storageKey = getGoodsDetailSelectedCountryStorageKey(currentServer);
    if (normalizedValue) {
      window.localStorage.setItem(storageKey, normalizedValue);
    } else {
      window.localStorage.removeItem(storageKey);
    }
  } catch (error) {}

  return normalizedValue;
}

export function resolveGoodsDetailSelectedCountryValue(
  countryList = [],
  preferredValue = "",
) {
  const normalizedPreferredValue = normalizeCompareText(preferredValue);
  if (!normalizedPreferredValue || !Array.isArray(countryList) || !countryList.length) {
    return "";
  }

  const matchedCountry = countryList.find((item) => {
    return [
      item?.value,
      item?.code,
      item?.label,
      item?.aliasName,
      item?.name,
      item?.country,
    ].some(candidate => normalizeCompareText(candidate) === normalizedPreferredValue);
  });

  return normalizeText(matchedCountry?.value || matchedCountry?.code);
}
